import React, { useEffect, useState, useRef } from "react";
import { Modal, Button, Table, Form, Spinner } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";

export default function AccountPickerModal({ show, onHide, onSelect, switchFilter }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const searchRef = useRef(null);
  const lastFetchedRef = useRef(null);

  const fetchAccounts = async (currentSearch = "") => {
    const q = (currentSearch || "").trim();
    lastFetchedRef.current = q;
    try {
      setLoading(true);
      let url = `/accounts?skip=0&limit=2000&sort_by=code&sort_order=asc`;
      if (q) {
        url += `&search=${encodeURIComponent(q)}`;
      }
      if (switchFilter) {
        url += `&switch=${switchFilter}`;
      }
      const data = await authFetch(url);
      const rows = Array.isArray(data) ? data : (data.items ?? []);
      setItems(rows);
    } catch (e) {
      console.error("Eroare conturi:", e);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch immediately on show or switchFilter changes
  useEffect(() => {
    if (show) {
      setSearch("");
      fetchAccounts("");

      // focus după ce modalul s-a montat
      setTimeout(() => {
        searchRef.current?.focus();
      }, 100);
    }
  }, [show, switchFilter]);

  // Debounced search on typing
  useEffect(() => {
    if (!show) return;
    const q = search.trim();
    if (lastFetchedRef.current === q) return;

    const handler = setTimeout(() => {
      fetchAccounts(search);
    }, 300);

    return () => clearTimeout(handler);
  }, [search, show]);

  const filtered = items.filter((it) => {
    const q = search.toLowerCase();
    return (
      String(it.code ?? it.cod ?? "")
        .toLowerCase()
        .includes(q) ||
      String(it.denumire ?? it.name ?? "")
        .toLowerCase()
        .includes(q)
    );
  });

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Alege cont</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Control
          ref={searchRef}
          placeholder="Caută după cod sau denumire..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="mb-3"
        />

        {loading ? (
          <Spinner />
        ) : (
          <Table hover size="sm">
            <thead>
              <tr>
                <th style={{ width: 120 }}>Cod</th>
                <th>Denumire</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((it) => (
                <tr
                  key={it.id}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    onSelect(it);
                    onHide();
                  }}
                >
                  <td style={{ fontFamily: "monospace" }}>
                    {it.code ?? it.cod}
                  </td>
                  <td>{it.denumire ?? it.name}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Închide
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
